import CentroCostoService from 'src/modules/centroCosto/centroCostoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import CentroCostoListActions from 'src/modules/centroCosto/list/centroCostoListActions';

const prefix = 'CENTROCOSTO_FORM';

const centroCostoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: centroCostoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CentroCostoService.find(id);
      }

      dispatch({
        type: centroCostoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: centroCostoFormActions.INIT_ERROR,
      });

      getHistory().push('/centro-costo');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: centroCostoFormActions.CREATE_STARTED,
      });

      await CentroCostoService.create(values);

      dispatch({
        type: centroCostoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.centroCosto.create.success'),
      );

      // getHistory().push('/centro-costo');

      dispatch(
        CentroCostoListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: centroCostoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: centroCostoFormActions.UPDATE_STARTED,
      });

      await CentroCostoService.update(id, values);

      dispatch({
        type: centroCostoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.centroCosto.update.success'),
      );

      // getHistory().push('/centro-costo');

      dispatch(
        CentroCostoListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: centroCostoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default centroCostoFormActions;
